( function( $ ) {
	$( document ).ready( () => {

		function slick_slider() {
			$( '.js-mobile-slider' ).slick( {
				dots: true,
				infinite: true,
				speed: 300,
				slidesToShow: 1,
				centerMode: true,
				variableWidth: true,
				prevArrow: false,
				nextArrow: false,
				mobileFirst: true,
				responsive: [
					{
						breakpoint: 768,
						settings: 'unslick'
					}
				]
			} );
		}

		slick_slider();

		window.addEventListener( 'resize', slick_slider );

	} );
} ) ( jQuery );



// WEBPACK FOOTER //
// ./assets/js/partials/mobile-slider.js